let mixpanelToken = '8d04b97f4b331aaf1f3907a58ac80558';

export {
    mixpanelToken
}